export enum WareneingangStatus {
  Offen = 'OFFEN',
  InBearbeitung = 'IN_BEARBEITUNG',
  Abgeschlossen = 'ABGESCHLOSSEN',
}